import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getDashboardContentsCall,
  getContentsByTypeCall,
  getNewContentsCall,
  getMyContentsCall,
  getTagsCall,
  getContentDetailsCall,
  getContentsInProgressCall,
  getContentStartCall,
  postContentStartCall,
  postContentProgressCall,
  postContentEndCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getDashboardContentsCall.saga,
  getContentsByTypeCall.saga,
  getNewContentsCall.saga,
  getMyContentsCall.saga,
  getTagsCall.saga,
  getContentDetailsCall.saga,
  getContentsInProgressCall.saga,
  getContentStartCall.saga,
  postContentStartCall.saga,
  postContentProgressCall.saga,
  postContentEndCall.saga,
];

export function* trainingContentsOrchestratorRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
